<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import SkillBase from '../../../../../skills/components/SkillBase.vue'

definePage({
  meta: {
    requiresAuth: true,
    requiresOrganisation: true,
    hideLeftColumn: true,
    hideRightColumn: true,
    featureFlags: 'skills',
  },
})

// The settings layout hands every tab the site; this one reads it from the site context instead
defineOptions({ inheritAttrs: false })
</script>

<template>
  <SkillBase />
</template>
